import 'twin.macro';
import 'styled-components/macro';
import { useState } from 'react';

import { Switch } from 'component-lib/atoms/controls/Switch';
import { useAuthenticationContext } from 'core/context/Authentication';
import { useLocalStorage } from 'support/react/hooks';

import { flags } from './flags';
import { ReactComponent as ArrowLeft } from './images/arrow-left.svg';
import { ReactComponent as ArrowRight } from './images/arrow-right.svg';

export type Flag = keyof typeof flags;

export const FeatureFlagManager = () => {
  const [showFeatureManager] = useLocalStorage('feature_manager', { initialValue: true });
  const { instruqtUser } = useAuthenticationContext();
  const [open, setOpen] = useState(false);

  if (!showFeatureManager || !instruqtUser?.is_global_admin) {
    return null;
  }

  return (
    <div tw="fixed bottom-[30px] right-0 flex grow-0 items-end z-overlay">
      <button tw="p-1 bg-primary text-white relative bottom-[10px] rounded-l-sm" onClick={() => setOpen(open => !open)}>
        {open ? <ArrowRight width={15} height={15} /> : <ArrowLeft width={15} height={15} />}
      </button>
      {open && <FeatureFlags />}
    </div>
  );
};

const FeatureFlags = () => {
  return (
    <div tw="bg-white p-2 w-[300px] flex flex-col gap-1 border-[1px] border-primary border-r-0 rounded-l-sm">
      <h3 tw="display-5 mb-1">Feature flags</h3>
      {Object.keys(flags).length ? (
        Object.entries(flags).map(
          ([key, title]): React.ReactElement => (
            <FeatureFlag key={key as Flag} name={key as Flag} title={String(title)} />
          ),
        )
      ) : (
        <h3 tw="text-gray-50">No feature flag has been found</h3>
      )}
    </div>
  );
};

/**
 * Use this hook to get the status of feature flag through the app
 *
 * @param name Name of the feature flag
 */
export const useFeatureFlag = (name: Flag) => {
  const [isFeatureActive, setIsFeatureActive] = useLocalStorage(name, { initialValue: false });

  return [isFeatureActive, setIsFeatureActive] as const;
};

const FeatureFlag = ({ name, title }: { name: Flag; title: string }) => {
  const [isFeatureActive, setIsFeatureActive] = useFeatureFlag(name);

  return (
    <Switch
      value={isFeatureActive}
      onChange={() => {
        setIsFeatureActive(!isFeatureActive);
        window.location.reload();
      }}
    >
      {title}
    </Switch>
  );
};
